// test2490
(2490 && 0);
